export const SET_INV_CREDITS = 'SET_INV_CREDITS';
export const CREATE_INV_CREDITS = 'CREATE_INV_CREDITS';
export const UPDATE_INV_CREDITS = 'UPDATE_INV_CREDITS';